import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceCart = (props) => {

    const { cart, setCart, selectedCurrency, cartItem, setJournalVoucher, openAddProductModal } = props;

    const { userData, settingData, salableData, rateFromToCurrency } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [spinning, setSpinning] = React.useState(false);
    const [scannedBarcode, setScannedBarcode] = useState("");


    useEffect(() => {
        setCart([cartItem])
        setJournalVoucher((prev) => ({
            ...prev,
            discountAmount: 0,
            discountPercentage: 0,
        }));
    }, [selectedCurrency]);



    // Product Options
    const productOptions = salableData?.map(item => ({
        value: item.id,
        label: `${item.sku ? ` (${item.sku}) ` : ''}  ${item.name} ${item.barcode ? ` [${item.barcode}]` : ''}`,
        id: item.id,
        categoryId: item.categoryId,
        productId: item.id,
        type: item.type,
        name: item.name,
        barcode: item.barcode,
        cost: item.cost,
        isStock: item.isStock,
        stock: item.totalStock,
        units: item.units,
        unit: item.unit,
        vat: item.vatGroup?.vat,
        currency: item.currency,
    }))

    const filterProducts = (inputValue, options) => {
        return options.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadProductOptions = (inputValue, callback) => {
        if (inputValue) {
            callback(filterProducts(inputValue, productOptions));
        } else {
            callback([]);
        }
    };



    // Add new row
    const handleAddRow = () => {
        setCart((prevCart) => [...prevCart, cartItem]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event, type) => {
        event.preventDefault()

        if (cart.length > 1) {
            const updatedRows = cart.slice(0, -1);
            setCart(updatedRows);
        } else {
            toast.error('you need at least one item')
        }


    };

    const handleDeleteRowIndex = (index) => {
        const updatedRows = cart.filter((_, i) => i !== index);
        setCart(updatedRows);

    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedCart = [...cart];


        if (field == 'product') {
            updatedCart[index].productId = value.id;
            updatedCart[index].cost = rateFromToCurrency(value.currency, selectedCurrency, value.cost);
            updatedCart[index].units = value.units;
            updatedCart[index].unitQuantity = 1;
            updatedCart[index].quantity = 1;
            updatedCart[index].index = index;
            updatedCart[index].isStock = value.isStock;
            updatedCart[index].type = value.type;
            updatedCart[index].vatPercentage = value.vat;

            updatedCart[index].accountId = settingData.purchaseAccountId;


        } else if (field == 'cost') {
            updatedCart[index].cost = parseFloat(value);

        } else if (field == 'quantity') {
            updatedCart[index].quantity = value;

        } else if (field == 'unitQuantity') {
            updatedCart[index].unitQuantity = value;

        } else if (field == 'freeQuantity') {
            updatedCart[index].freeQuantity = value;

        } else if (field == 'details') {
            updatedCart[index].details = value;

        }
        else if (field == 'costDiscountAmount') {
            updatedCart[index].costDiscountAmount = value;
            updatedCart[index].costDiscountPercentage = (updatedCart[index].costDiscountAmount / (updatedCart[index].cost * updatedCart[index].quantity)) * 100;

        }
        else if (field == 'costDiscountPercentage') {
            updatedCart[index].costDiscountPercentage = value;
        }
        else if (field == 'vatPercentage') {
            updatedCart[index].vatPercentage = value;
        }

        updatedCart[index].subQuantity = updatedCart[index].quantity * updatedCart[index].unitQuantity;
        updatedCart[index].netQuantity = parseFloat(updatedCart[index].subQuantity) + parseFloat(updatedCart[index].freeQuantity);

        updatedCart[index].costDiscountAmount = (updatedCart[index].costDiscountPercentage / 100) * (updatedCart[index].cost * updatedCart[index].subQuantity);

        const subCost = (updatedCart[index].cost * updatedCart[index].subQuantity);

        const totalCost = subCost - updatedCart[index].costDiscountAmount;

        updatedCart[index].vatAmount = (updatedCart[index].vatPercentage / 100) * (totalCost);

        updatedCart[index].totalCost = totalCost;
        updatedCart[index].netCost = totalCost / updatedCart[index].netQuantity;

        setCart(updatedCart);
    }


    const handleBarcodeScan = (e) => {
        const barcode = e.target?.value;
        const product = productOptions?.find(option => option.barcode === barcode);

        if (!product) {
            toast.error('Product not found');
            setScannedBarcode('');
            return;
        }

        setCart((prevCart) => {
            let updatedCart = [...prevCart];
            const existingProductIndex = updatedCart.findIndex(option => option.productId === product.id);

            if (existingProductIndex > -1) {
                let quantity = updatedCart[existingProductIndex].quantity + parseFloat(1);
                handleRowChange(existingProductIndex, quantity, 'quantity');
            } else {
                // Add new product row
                const productItem = {
                    accountId: settingData?.purchaseAccountId,
                    productId: product.id,
                    cost: rateFromToCurrency(product.currency, selectedCurrency, product.cost),
                    units: product.units,
                    type: product.type,
                    unitQuantity: 1,
                    subQuantity: 1,
                    freeQuantity: 0,
                    costDiscountAmount: 0,
                    costDiscountPercentage: 0,
                    netQuantity: 1,
                    totalCost: product.cost,
                    quantity: 1,
                    vatPercentage: product.vat,
                    vatAmount: (product.vat / 100) * (rateFromToCurrency(product.currency, selectedCurrency, product.cost)),
                };

                if (cart.length == 1 && !cart[0].productId) {
                    updatedCart = [productItem];
                } else {
                    updatedCart.push(productItem);
                }

            }

            return updatedCart;
        });

        setScannedBarcode('');
    };




    return (

        <div>

            <Spin spinning={spinning} fullscreen />


            <Row >
                <Col md={2}>
                    <Form.Label>Select Products</Form.Label>
                    <FaPlus onClick={() => openAddProductModal()} style={{ marginLeft: '20px', marginBottom: '3px', cursor: 'pointer' }} />

                </Col>


                <Col>
                    <Form.Label>Unit</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Quantity</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Free Qty</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Unit Cost</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Discount %</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Discount</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Total Cost</Form.Label>
                </Col>


                <Col>
                    <Form.Label>VAT %</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Details</Form.Label>
                </Col>

            </Row>



            {cart.map((row, index) => (


                <Row className="g-0 mb-1" key={index}>
                    <Col md={2}>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={loadProductOptions}
                            defaultOptions={[]}
                            onChange={(e) => handleRowChange(index, e, 'product')}
                            value={productOptions?.find(option => option.value === cart[index].productId) || []}
                            noOptionsMessage={() => 'type to view'}
                            required
                        />
                    </Col>

                    {/* Units  Quantity*/}
                    <Col>
                        <Form.Select className="form-control form-control-sm" name='unitQuantity'
                            value={cart[index].unitQuantity}
                            onChange={(e) => handleRowChange(index, e.target.value, 'unitQuantity')}>
                            <option value={1}>{cart[index]?.unit} (x1)</option>
                            {cart[index]?.units?.map((unit, unitIndex) => (
                                <option key={index} value={unit.value}>{unit.unit} (x{unit.value})</option>
                            ))}

                        </Form.Select>
                    </Col>

                    {/*  Quantity  */}
                    <Col>
                        <Form.Control type="number" min={0} step='any'
                            onChange={(e) => handleRowChange(index, e.target.value, 'quantity')}
                            style={{ backgroundColor: '#f0f8ff' }}
                            value={cart[index].quantity}
                            required
                        />
                    </Col>

                    {/*  Free Quantity  */}
                    <Col>
                        <Form.Control type="number" min={0} step='any'
                            onChange={(e) => handleRowChange(index, e.target.value, 'freeQuantity')}
                            style={{ backgroundColor: '#ebfadd' }}
                            value={cart[index].freeQuantity}
                            required
                        />
                    </Col>

                    {/* Cost */}
                    <Col>
                        <Form.Control type="number" min={0} step='any' value={cart[index].cost}
                            style={{ backgroundColor: '#f7e8e8' }}
                            onChange={(e) => handleRowChange(index, e.target.value, 'cost')}
                            required
                        />
                    </Col>

                    {/* discount % */}
                    <Col>
                        <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].costDiscountPercentage}
                            onChange={(e) => handleRowChange(index, e.target.value, 'costDiscountPercentage')}
                            required
                        />
                    </Col>



                    {/* discount amount */}
                    <Col>
                        <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].costDiscountAmount}
                            onChange={(e) => handleRowChange(index, e.target.value, 'costDiscountAmount')}
                            required
                        />
                    </Col>


                    {/* total cost */}
                    <Col>
                        <Form.Control type="number" name="total" id="total"
                            value={cart[index].totalCost}
                            disabled />
                    </Col>


                    {/* VAT % */}
                    <Col>
                        <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index].vatPercentage}
                            onChange={(e) => handleRowChange(index, e.target.value, 'vatPercentage')}
                            required
                        />
                    </Col>


                    {/* Details */}
                    <Col>
                        <Form.Control as="textarea" rows={1}
                            value={cart[index].details}
                            onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                        />
                    </Col>


                    <Col className="d-flex justify-content-end" style={{ flex: 0.2 }}>
                        <BiSolidTrash size={18} onClick={e => handleDeleteRowIndex(index)}
                            style={{ cursor: 'pointer', color: '#e6434f', marginTop: '10px' }} />
                    </Col>

                </Row>




            ))}





            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('cart')} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'cart')} />

                </Col>

            </Row>

            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <InputGroup style={{ backgroundColor: '#f0f8ff', width: '20%' }}>
                        <Form.Control type="text" placeholder='scan barcode to add ..'
                            value={scannedBarcode} onChange={e => setScannedBarcode(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') { handleBarcodeScan(e); } }} />
                        <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>

        </div>

    )
}


export default InvoiceCart;